// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { timelyIntegrationCloudV1UserAccountsSchema } from './timelyIntegrationCloud/v1/userAccountsSchema';

/**
 * @description user accounts details
 */
export const getUserAccounts200Schema = z.lazy(() => timelyIntegrationCloudV1UserAccountsSchema);

/**
 * @description Unauthorized
 */
export const getUserAccounts401Schema = z.object({
  errors: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
});

export const getUserAccountsQueryResponseSchema = z.lazy(() => getUserAccounts200Schema);
